import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { Icon2gProps } from './Icon2g.types'
import * as Styled from './styles/Icon2g.style'

import { nonThemeableRules } from '../../ruleSet'

const Icon2g: FC<Icon2gProps> = ({
  size = nonThemeableRules.defaultSize as number as Icon2gProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: Icon2gProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
        <g fill='none'>
          <path
            d='M15.25 12.242H17v1.5a1.192 1.192 0 0 1-.875 1.188c-1.035.28-3.125.465-3.125-2.938 0-3.687 3.32-3.234 3.813-2.312'
            vectorEffect='non-scaling-stroke'
          />
          <path d='M21.5 12c0 5.246-4.254 9.5-9.5 9.5S2.5 17.246 2.5 12 6.754 2.5 12 2.5h9.5Zm0 0' vectorEffect='non-scaling-stroke' />
          <path
            d='M9.95 11.73c.355-.261.57-.675.573-1.117 0-.824-.78-1.597-1.75-1.597a1.645 1.645 0 0 0-1.449.8m3.466 5.215H7.18c0-.57.25-1.113.68-1.484l2.117-1.836'
            vectorEffect='non-scaling-stroke'
          />
        </g>
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default Icon2g
